/**
 * `router/index.js`
 *  -  各ページ固有のスクリプトの統合
 *
 * 使用方法:
 *  - import {initRouter} from "./router/index.js";
 */


import {config} from "../config.js";
import routeCommon from "./common.js";
import {homeRouter} from "./home.js";

import {conceptRouter} from "./concept.js";

import {newsRouter} from "./news.js";
import {contactRouter} from "./contact.js";
import {getNamespace} from "../utils/dom.js";


/**
 * ページごとのスクリプト管理
 */
const routes = {
  home: homeRouter,
  concept: conceptRouter,
  news: newsRouter,
  contact: contactRouter,
};



export const router = {

  /**
   * 初回ロード & Barbaオフ時のルーター処理
   * @param {Object} data - barba.js の `data.next.namespace`
   */
  init (data) {

    const namespaceRaw = getNamespace(data);
    const namespace = namespaceRaw.replace(/-([a-z])/g, (_, char) => char.toUpperCase());

    // barbaオフ時のルーター処理
    if (!config.useBarba) {
      routeCommon.beforeEnter(data);  // barbaがOFFの時だけ実行、ONの時はbarba内で実行（TODO OFFの時は不要かも）

      // ページ固有処理
      if (namespace && routes[namespace]) {
        routes[namespace](data);
      }

      routeCommon.afterEnter(data);  // barbaがOFFの時だけ実行、ONの時はbarba内で実行
    }

    routeCommon.after(data);  // barbaがOFFの時だけ実行、ONの時はbarba内で実行
    routeCommon.once(data); // 初回ロード時のみ実行
  },


  /**
   * Barba遷移時の動的ルーター処理
   * @param {Object} data - barba.jsの `data.next.namespace`
   */
  barba (data) {
    console.log("🚏 Running router.barba (Barba Navigation)");

    const namespaceRaw = getNamespace(data);
    const namespace = namespaceRaw.replace(/-([a-z])/g, (_, char) => char.toUpperCase());

    if (namespace && routes[namespace]) {
      routes[namespace](data); // ページ固有のスクリプトを実行
    }
  }
};


/**
 * ルーターの初期化
 * @param {Object} data barba.jsの `data.next.namespace`
 */
export const initRouter = (data = null) => {
  console.log("🚏 Initializing Router...");
  router.init(data);
};
